const ORDER_TRADE_IN_RESULTS_EVENT_HANDLERS = (() => {
  const initBackToLookupEventHandlers = () => {
    // The "back to lookup" link is ALSO effectively a signout link.
    document.querySelector('.back-to-lookup__link').addEventListener(
      'click',
      () => {
        ORDER_TRADE_IN_LOOKUP_TOKEN_UTILS.clearSavedToken();
      },
    );
  };

  const initTabEventHandlers = () => {
    // Clicking an already selected tab should be a no-op. The optional chaining operator is b/c
    // tabs won't even be rendered unless multiple tabs are configured.
    document.querySelector('.order-trade-in-results-tabs__tab--selected')?.addEventListener(
      'click',
      e => e.preventDefault(),
    );
  };

  const initThumbnailEventHandlers = () => {
    let timeoutId;
    // We use JS to decide how many image thumbnails to render based on screen size, so need to
    // re-run that JS when the screen size changes. Debounce to avoid jittery appearance and poor
    // performance.
    window.addEventListener('resize', () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(
        () => {
          document.querySelectorAll('order-trade-in-lookup-result-thumbnails').forEach(
            (thumbnailsEl) => {
              thumbnailsEl.handleResizeEvent();
            },
          );
        },
        150,
      );
    });
  };

  /**
   * Init event handlers common to the order-lookup-results and trade-in-lookup-results pages.
   */
  const initEventHandlers = () => {
    initBackToLookupEventHandlers();
    initTabEventHandlers();
    initThumbnailEventHandlers();
  };

  return {
    initEventHandlers,
  };
})();
